import { newDataLayer, registerDataLayer } from '../../utilities/google-tools';

import { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { UserActivityStatus } from '../../common/enum';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  logUserActivity,
  NOTIFICATIONS_CLEARED_AT_PREFIX,
} from '../../api/api-functions';
import { logout } from '../../actions/authentication-actions';
import { setAuthorizationToken } from '../../utilities/api-helper';

const PERSISTED_REDUX_KEY = 'persist:root';

const clearPersistedReduxState = () => {
  localStorage.removeItem(PERSISTED_REDUX_KEY);
};

export const clearAppCache = () => {
  const preserved = Object.keys(localStorage)
    .filter((key) => key.startsWith(NOTIFICATIONS_CLEARED_AT_PREFIX))
    .map((key) => [key, localStorage.getItem(key)]);

  localStorage.clear();
  sessionStorage.clear();
  clearPersistedReduxState();

  preserved.forEach(([key, value]) => {
    if (value != null) localStorage.setItem(key, value);
  });

  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }

  window.setTimeout(clearPersistedReduxState, 0);
};

class Logout extends Component {
  componentWillMount() {
    this.props.logout();
    logUserActivity(UserActivityStatus.Logout);
    setAuthorizationToken(null);
    clearAppCache();
    registerDataLayer(newDataLayer('Logout'))
  }

  render() {
    if (this.props.match.params.autoLogout === true)
      return <Redirect to={'/Login/' + this.props.match.params.autoLogout} />;
    else return <Redirect to={'/Login'} />;
  }
}

function matchDispatchToProps(dispach) {
  return bindActionCreators({ logout: logout }, dispach);
}

export default connect(null, matchDispatchToProps)(Logout);
